import { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import configData from "../config.json";
import axios from "axios";
import "../styles/banner.css"; // 👈 important

const Home = () => {
  const [loading, setLoading] = useState(true);

  const banners = [
    { img: "pil.png", title: "Pragoti Industries Limited", subtitle: "Powering the Nation’s Journey" },
    { img: "abl.png", title: "Atlas Bangladesh Limited", subtitle: "Go With Green" },
    { img: "ntl.png", title: "National Tubes Limited", subtitle: "High-Strength Pipes for Industrial and Infrastructure Solutions" },
    { img: "bbfl.png", title: "Bangladesh Blade Factory Ltd.", subtitle: "Precision Manufacturing for Quality Cutting Solutions"},
    { img: "ecl.png", title: "Eastern Cables Ltd.", subtitle: "Reliable Cable Solutions for Power Transmission & Distribution"},
    { img: "etl.png", title: "Eastern Tubes Ltd.", subtitle: "Delivering Quality Electrical Solutions"},
    { img: "gwl.png", title: "Gazi Wires Limited", subtitle: "High Performance Super Enamelled Copper Wire Manufacturing"}
  ];

  useEffect(() => {
    const getVisitorCount = async () => {
      try {
        const res = await axios.get(`${configData.SERVER_URL}/visitorCount`);
        localStorage.setItem("visitCount", res.data.count);
      } catch (err) {
        console.error("Visitor count error:", err);
      } finally {
        setLoading(false);
      }
    };

    getVisitorCount();
  }, []);

  return (
    <div className="container py-3">
      <div className="shadow rounded overflow-hidden">

        {loading ? (
          <div className="text-center py-5">Loading banners...</div>
        ) : (

          <Carousel
            autoPlay
            infiniteLoop
            showThumbs={false}
            showStatus={false}
            interval={5000}
            transitionTime={800}
            swipeable
            stopOnHover
          >

            {banners.map((item, index) => (
              <div key={index} className="banner-slide">

                {/* Image */}
                <img
                  src={`${configData.IMAGE_URL}/orgBanner/${item.img}`}
                  alt={item.title}
                  className="banner-img"
                />

                {/* Overlay */}
                <div className="banner-overlay">
                  <h2>{item.title}</h2>
                  <p>{item.subtitle}</p>
                </div>

              </div>
            ))}

          </Carousel>

        )}
      </div>
    </div>
  );
};

export default Home;